import { useMemo } from 'react';

import * as stepsMeasurement from '../../../../redux/profiles/patientHealthboard/steps-measurements-req';
import * as stepsMeasurementModal from '../../../../redux/profiles/patientHealthboard/steps-measurements-modal-req';
import * as distanceMeasurement from '../../../../redux/profiles/patientHealthboard/distance-measurements-req';
import * as distanceMeasurementModal from '../../../../redux/profiles/patientHealthboard/distance-measurements-modal-req';
import * as bmiMeasurement from '../../../../redux/profiles/patientHealthboard/bmi-measurements-req';
import * as bmiMeasurementSingleDayModal from '../../../../redux/profiles/patientHealthboard/bmi-measurements-modal-req';
import * as weightMeasurement from '../../../../redux/profiles/patientHealthboard/weight-measurements-req';
import * as weightMeasurementModal from '../../../../redux/profiles/patientHealthboard/weight-measurements-modal-req';
import * as heightMeasurement from '../../../../redux/profiles/patientHealthboard/height-measurements-req';
import * as heightMeasurementModal from '../../../../redux/profiles/patientHealthboard/height-measurements-modal-req';
import * as saturationMeasurement from '../../../../redux/profiles/patientHealthboard/saturation-measurements-req';
import * as saturationMeasurementModal from '../../../../redux/profiles/patientHealthboard/saturation-measurements-modal-req';
import * as heartRateMeasurement from '../../../../redux/profiles/patientHealthboard/heart-rate-measurements-req';
import * as heartRateMeasurementModal from '../../../../redux/profiles/patientHealthboard/heart-rate-measurements-modal-req';
import * as bloodPressureMeasurement from '../../../../redux/profiles/patientHealthboard/bloodPressure-measurements-req';
import * as respiratoryRateMeasurement from '../../../../redux/profiles/patientHealthboard/respiratoryRate-measurements-req';
import * as bloodGlucoseMeasurementModal from '../../../../redux/profiles/patientHealthboard/blood-glucose-measurements-modal-req';
import * as bloodGlucoseMeasurement from '../../../../redux/profiles/patientHealthboard/blood-glucose-measurements-req';
import { VITALS_ACTIVITY_TYPE } from '../../constants';

const {
  HEART_RATE,
  DISTANCE,
  STEPS,
  SATURATION,
  BMI,
  WEIGHT,
  HEIGHT,
  BLOOD_PRESSURE,
  RESPIRATORY_RATE,
  BLOOD_GLUCOSE,
} = VITALS_ACTIVITY_TYPE;

export function useActionFilters(type, singleDayMode = false) {
  const getDataByType = useMemo(
    () => () => {
      switch (type) {
        case STEPS:
          return {
            clear: singleDayMode
              ? stepsMeasurementModal.actions.clear
              : stepsMeasurement.actions.clear,
            action: singleDayMode
              ? stepsMeasurementModal.actions.send
              : stepsMeasurement.actions.send,
          };
        case DISTANCE:
          return {
            clear: singleDayMode
              ? distanceMeasurementModal.actions.clear
              : distanceMeasurement.actions.clear,
            action: singleDayMode
              ? distanceMeasurementModal.actions.send
              : distanceMeasurement.actions.send,
          };
        case BMI:
          return {
            clear: singleDayMode
              ? bmiMeasurementSingleDayModal.actions.clear
              : bmiMeasurement.actions.clear,
            action: singleDayMode
              ? bmiMeasurementSingleDayModal.actions.send
              : bmiMeasurement.actions.send,
          };
        case WEIGHT:
          return {
            clear: singleDayMode
              ? weightMeasurementModal.actions.clear
              : weightMeasurement.actions.clear,
            action: singleDayMode
              ? weightMeasurementModal.actions.send
              : weightMeasurement.actions.send,
          };
        case HEIGHT:
          return {
            clear: singleDayMode
              ? heightMeasurementModal.actions.clear
              : heightMeasurement.actions.clear,
            action: singleDayMode
              ? heightMeasurementModal.actions.send
              : heightMeasurement.actions.send,
          };
        case SATURATION:
          return {
            clear: singleDayMode
              ? saturationMeasurementModal.actions.clear
              : saturationMeasurement.actions.clear,
            action: singleDayMode
              ? saturationMeasurementModal.actions.send
              : saturationMeasurement.actions.send,
          };
        case HEART_RATE:
          return {
            clear: singleDayMode
              ? heartRateMeasurementModal.actions.clear
              : heartRateMeasurement.actions.clear,
            action: singleDayMode
              ? heartRateMeasurementModal.actions.send
              : heartRateMeasurement.actions.send,
          };
        case BLOOD_PRESSURE:
          return {
            clear: bloodPressureMeasurement.actions.clear,
            action: bloodPressureMeasurement.actions.send,
          };
        case RESPIRATORY_RATE:
          return {
            clear: respiratoryRateMeasurement.actions.clear,
            action: respiratoryRateMeasurement.actions.send,
          };
        case BLOOD_GLUCOSE:
          return {
            clear: singleDayMode
              ? bloodGlucoseMeasurementModal.actions.clear
              : bloodGlucoseMeasurement.actions.clear,
            action: singleDayMode
              ? bloodGlucoseMeasurementModal.actions.send
              : bloodGlucoseMeasurement.actions.send,
          };
        default:
          return {
            clear: stepsMeasurement.actions.clear,
            action: stepsMeasurement.actions.send,
          };
      }
    },
    [type, singleDayMode],
  );

  return getDataByType();
}



// WEBPACK FOOTER //
// ./src/components/PatientHealthboard/Chart/Filters/useActionFilters.jsx